import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterFood'
})

export class FoodFilterPipe implements PipeTransform {
  transform(
    value: any,
    name: any = '',
    maxItens: number = 12,
    totalItens: any,
    lang: string,
  ): any {
    // tratando os filtros
    if (name.length < 3) name = '';

    // testando os filtros
    // se o argumento estiver diferente do filtro ou o filtro estiver vazio, descarta
    if (value === undefined || value === null) return null;
    const retorno = value.filter(
      (v: any) => {
        // nome
        if (name !== '') {
          if (lang === 'br') {
            let clean = this.removeAccents(v.name.toLowerCase()).indexOf(this.removeAccents(name.toLowerCase()));
            if (clean === -1) {
              return false;
              // return text.indexOf(search) > -1;
            }            
          }

          if (lang === 'es') {
            if (v.translations !== null) {
              let translated = JSON.parse(v.translations);
              let clean_es = this.removeAccents(translated.strings_es.name.toLowerCase()).indexOf(this.removeAccents(name.toLowerCase()));
              if (clean_es === -1) {
                return false;
              }
            }
            if (v.translations === null) return false;
          }

          if (lang === 'en') {
            if (v.translations !== null) {
              let translated = JSON.parse(v.translations);
              let clean_en = this.removeAccents(translated.strings_en.name.toLowerCase()).indexOf(this.removeAccents(name.toLowerCase()));
              if (clean_en === -1) {
                return false;
              }
            }
            if (v.translations === null) return false;
          }
        }

        return true;
      }
    );

    totalItens.count = retorno.length;

    // return retorno;
    return retorno.slice(0, maxItens);
  }

  testFilter(filter: any, prop: any) {
    if (filter.length === 1) {
      for (let a = 0; a < filter.length; a++) {
        for (let b = 0; b < prop.length; b++) {
          if (filter[a] === prop[b]) {
            return true;
          }
        }
      }
      return false;

    } else {
      let contFound = 0;
      for (let a = 0; a < filter.length; a++) {
        for (let b = 0; b < prop.length; b++) {
          if (filter[a] === prop[b]) {
            contFound++;
          }
        }
      }
      if (contFound === filter.length) {
        return true;
      } else {
        return false;
      }
    }
  }

  removeAccents(source: any) {
    if (source === undefined || source === null) return null;
    var accent = [
      /[\300-\306]/g, /[\340-\346]/g, // A, a
      /[\310-\313]/g, /[\350-\353]/g, // E, e
      /[\314-\317]/g, /[\354-\357]/g, // I, i
      /[\322-\330]/g, /[\362-\370]/g, // O, o
      /[\331-\334]/g, /[\371-\374]/g, // U, u
      /[\321]/g, /[\361]/g, // N, n
      /[\307]/g, /[\347]/g, // C, c
      /[\040-\057]/g,
      /[\072-\077]/g,
      /[\133-\137]/g,
      /[\173-\176]/g,
      /[\100]/g,
      /[\140]/g
    ],
    noaccent = ['A','a','E','e','I','i','O','o','U','u','N','n','C','c', "", "", "", "", "", ""];

    for (var i = 0; i < accent.length; i++){
        source = source.replace(accent[i], noaccent[i]);
    }

    return source;
  };

}
